export default __webpack_public_path__ + "static/media/about9.fa9088ac.jpeg";